import { Component, OnInit, Input } from '@angular/core';
import { News } from 'src/app/models/news';

@Component({
  selector: 'app-card-news',
  templateUrl: './card-news.component.html',
  styleUrls: ['./card-news.component.scss']
})
export class CardNewsComponent implements OnInit {
  @Input() news: News;

  constructor() { }

  ngOnInit() {
  }

}
